import React, {useContext, useState, useMemo, useEffect} from 'react';
import {
  Appbar,
  useTheme,
  TextInput,
  Searchbar,
  useAppThe,
} from 'react-native-paper';

import {getHeaderTitle} from '@react-navigation/elements';
import {View} from 'react-native';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';

import {
  ChatParams,
  FolderParams,
  ShopStackParams,
  UnifiedStackParams,
} from '../../../types/nav';

import uuid from 'react-native-uuid';

import {BackButton} from './backbutton';
import {setEditingMode} from '../../../store/slices/ui';
import {NativeStackNavigationOptions} from '@react-navigation/native-stack';
import {
  createNewParty,
  getById,
  getUserData,
  writeItem,
} from '../../../api';
import {
  NavigationProp,
  useNavigation,
} from '@react-navigation/native';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import {Folder, Media} from '../../../types';
export const defaulPlaceHolderText = 'type to search your collection';
export const addFolderPlaceholder = 'Type name of the folder';
export const searchContactsPlaceholderText =
  'type to search your contacts';
export const chatPlacehoder = 'Type name of the new chat';

export function NavInput({
  options,
  folderId,
  isLocked,
  searchValue,
  setSearch,
}: {
  options: NativeStackNavigationOptions;
  folderId: string;
  isLocked: boolean;
  searchValue: string;
  setSearch: (s: string) => void;
}) {
  const queryClient = useQueryClient();
  const navigation =
    useNavigation<NavigationProp<UnifiedStackParams>>();
  const params = useAppSelector(state => state.ui.params);
  const folderType = useAppSelector(state => state.ui.folderType);
  const dispatch = useAppDispatch();
  const isEditing = useAppSelector(state => state.ui.isEditing);
  const mode = useAppSelector(state => state.ui.editingMode);
  const [textValue, setText] = useState('');
  const routeName: string = useAppSelector(
    state => state.ui.currentPage,
  );
  const userData = useQuery('UserData', () => getUserData());
  const userId = userData?.data?.id as string;
  const theme = useTheme();
  const writeItemMutation = useMutation(
    (item: Media | Folder) => writeItem(item),
    {retry: true},
  );
  const folderDataQuery = useQuery(
    'folderData_' + folderId,
    async () => await getById(folderId as string),
    {retry: true, enabled: folderId ? true : false},
  );
  const folder = folderDataQuery.data;
  const back = useAppSelector(state => state.ui.isBackEnabled);
  const newFolderType = 'new_' + folderType;
  const title =
    (params as ChatParams)?.name ||
    (params as FolderParams)?.title ||
    getHeaderTitle(options, routeName!);
  let placeholderText = addFolderPlaceholder;
  const mnemonic = (params as ChatParams)?.mnemonic;
  const shopId = (params as ShopStackParams['Order'])?.shopId;
  if (mode === 'party') {
    placeholderText = chatPlacehoder;
  }
  if (mode === 'search') {
    placeholderText = 'type to search';
  }

  const onClickExtra = async () => {
    console.info('mode', mode);
    try {
      switch (mode) {
        case 'party':
          console.info('createNewParty');
          const partyId = userId + '_' + uuid.v4();
          const party = await createNewParty({
            id: partyId,
            name: textValue,
            partyId,
            folderId: folderId || newFolderType,
            isContact: true,
          });
          navigation.navigate('Chat', {
            chatId: partyId,
            name: textValue,
            mnemonic: party.mnemonic,
            parentFolderId: folderId || newFolderType,
          });
          console.info('createNewParty done', party);
          break;
        case 'folder':
          const newFolderId = 'folder_' + uuid.v4() + '_' + userId;
          const nFolder: Folder = {
            id: newFolderId,
            title: textValue,
            isFolder: true,
            date: new Date().valueOf(),
            userId,
            folderType,
            folderId: folderId || shopId,
            mnemonic,
          };
          console.info('new folder', nFolder);
          await writeItemMutation.mutateAsync(nFolder);
          break;

        case 'search':
          dispatch(setEditingMode(undefined));
          break;
      }
    } catch (err) {
      console.error('onClickExtra err', err);
    }
    if (folderId) {
      queryClient.refetchQueries({
        queryKey: 'folderContent_' + folderId,
      });
    } else {
      queryClient.refetchQueries({
        queryKey: 'folders_' + folderType,
      });
    }

    dispatch(setEditingMode(undefined));
    return true;
  };
  const showTextField = isEditing && mode !== 'database';
  return (
    <>
      {!showTextField && back ? (
        <BackButton folder={folder as Folder} />
      ) : null}

      {!showTextField ? (
        <Appbar.Content
          title={title}
          theme={theme}
          style={{paddingLeft: !back ? 15 : 0}}
        />
      ) : null}
      {showTextField ? (
        <View style={{width: '100%'}}>
          <TextInput
            placeholder={placeholderText}
            onChangeText={query =>
              mode === 'search' ? setSearch(query) : setText(query)
            }
            style={{
              width: '100%',
              textAlignVertical: 'bottom',
              lineHeight: 30,
              padding: 10,
              height: 40,
            }}
            theme={theme}
            value={mode === 'search' ? searchValue : textValue}
            left={
              <TextInput.Icon
                style={{marginTop: 20}}
                icon="arrow-left-circle"
                onPress={() => {
                  dispatch(setEditingMode(undefined));
                }}
              />
            }
            autoFocus
            maxLength={100}
            right={
              <TextInput.Icon
                style={{marginTop: 20}}
                onPress={onClickExtra}
                icon="check-circle"
                loading={isLocked}
              />
            }
          />
        </View>
      ) : null}
    </>
  );
}
